import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavService} from '../../../../_services/_nav.service';
import {PlataformaDigitalService} from '../../../../_services/plataforma-digital.service';
import {SolicitudOfertaGarantiaService} from '../../../../_services/solicitud-oferta-garantia.service';
import {forkJoin, Subscription} from 'rxjs';
import {ExcelAvance} from '../../../../_models/excel-avance';
import {Message} from '@stomp/stompjs';
import {RxStompService} from '@stomp/ng2-stompjs';
import {AutenticacionService} from '../../../../_services/autenticacion.service';
import {UtilitiesService} from '../../../../utils/utilities.service';
import {Table} from "primeng/table";
import {CambioEstadosComponent} from '../../../cambio-estados/cambio-estados.component';
import {BotonesSolicitud} from '../../../../_enums/enum';
import {ConfirmationService} from 'primeng/api';
import {FormBuilder} from '@angular/forms';
import {DialogService} from 'primeng/dynamicdialog';
import {ParametriaService} from '../../../../_services/parametria.service';
import {Parametria} from '../../../../_models/parametrias';

@Component({
  selector: 'app-fondo-garantia',
  templateUrl: './fondo-garantia.component.html',
  styleUrls: ['./fondo-garantia.component.css']
})
export class FondoGarantiaComponent implements OnInit, OnDestroy {

  loading = true;
  contador: number;
  columnas: any[] = [];
  showModalSolicitudes = false;
  cargandoTabla = false;
  listSolicitudes: any[] = [];
  lanIntegracion = false;

  procesoSocket = false;
  ingresoUnico = true;

  private topSubscription: Subscription;
  excelAvance: ExcelAvance;

  modalVerificacion = {verificando: false, estActual: null, error: false, individual: false};

  parametria: Parametria;

  constructor(private navServicio: NavService,
              private plataformaDigital: PlataformaDigitalService,
              private solicitudOfertaGarantia: SolicitudOfertaGarantiaService,
              private rxStompService: RxStompService,
              private authService: AutenticacionService,
              public utilitiesService: UtilitiesService,
              private conServicio: ConfirmationService,
              private diaService: DialogService,
              private parametriaService: ParametriaService) { }

  async ngOnInit() {
    this.contador = 0;
    this.loading = false;
    await this.cargarContador();
    this.columnas = [
      { field: 'idSolicitud', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_NUMEROSOLICITUD' ), sort: true, check: false },
      { field: 'fechaSolicitud', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_FECHASOLICITUD' ), sort: true, check: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_METODO' ), sort: true, check: false },
      { field: 'error', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_ERROR' ), sort: false, check: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false, check: false }
    ];

    window.onbeforeunload = () => this.ngOnDestroy();
    this.conectarSocket();
    await this.consultarProcesoFga();
  }

  async consultarProcesoFga() {
    const estadoFga = await this.parametriaService.listado().toPromise();
    if (estadoFga && estadoFga[0]?.indicadorProcesandoFga) {
      this.parametria = estadoFga[0];
      console.log( estadoFga );
      this.ingresoUnico = false;
      this.procesoSocket = true;
      this.navServicio.setMesageToast(
        {
          key: 'toastMessage',
          severity: "info",
          life: 10000,
          summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_VERIFICACIONENCURSOFGA' ),
        }
      );
    } else {
      this.ingresoUnico = false;
      this.procesoSocket = false;
    }
  }

  habilitarEnviarIntegraciones() {
    if ( this.parametria && this.parametria ) {
      this.parametria.indicadorProcesandoFga = false;
      this.parametriaService.actualizar(this.parametria).subscribe(e => {
        this.ingresoUnico = false;
        this.procesoSocket = false;
      });
    }
  }

  async cargarContador() {
    const pendientes = await this.solicitudOfertaGarantia.contadorPendienteEnviar().toPromise();
    this.contador = pendientes;
  }

  cargarSolicitudes() {
    this.cargandoTabla = true;
    this.solicitudOfertaGarantia.solicitudEnviadoFGA().subscribe(async lista => {
      this.listSolicitudes = lista;
      this.showModalSolicitudes = true;
      await this.consultarProcesoFga();
      this.cargandoTabla = false;
    }, error => {
      this.cargandoTabla = false;
      this.navServicio.setMesage(0, {
        severity: 'error', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
      });
    });
  }
  mostrarErrorEnModal(data: {[key:string]: any}, mensaje: string) {
    const simbolos = ['{', '}', '@', '"'];
    const contieneSimbolo = simbolos.some(simbolo => mensaje.includes(simbolo));

    const contienePunto = mensaje.includes('.') && mensaje[mensaje.length - 1] !== '.';

    const contieneNumero = /\d/.test(mensaje);

    const mismoErrorAnterior = mensaje === data.errorGarantia;

    return contieneSimbolo || contienePunto || contieneNumero || mismoErrorAnterior;
  }

  enviarIntegracionIndividual(data: {[key:string]: any}) {
    if ( this.lanIntegracion) {
      return;
    }
    this.lanIntegracion = true;
    this.modalVerificacion.estActual = 'INIT';
    this.modalVerificacion.verificando = true;
    this.modalVerificacion.individual = true;
    this.solicitudOfertaGarantia.verificarIntegracionIndividual(data.idSolicitudOfertaGarantia).subscribe(res => {
      if (res.error && !this.mostrarErrorEnModal(data, res.mensaje)) {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: res.mensaje
        } );
        if (res.indicadorEnviadoFGA) {
          this.listSolicitudes = this.listSolicitudes.filter(s => s.idSolicitudOfertaGarantia !== data.idSolicitudOfertaGarantia);
        }
        this.modalVerificacion.estActual = null;
        this.cerrarVerificacion(true);
      } else {
        this.modalVerificacion.estActual = 'FINVER';
        if (res.error) {
          this.excelAvance = {} as ExcelAvance;
          this.excelAvance.errores = [];
          this.excelAvance.errores.push(res.mensaje);
          this.modalVerificacion.error = true;
        } else {
          this.listSolicitudes = this.listSolicitudes.filter(s => s.idSolicitudOfertaGarantia !== data.idSolicitudOfertaGarantia);
        }
      }
      this.lanIntegracion = false;
    }, error => {
      this.modalVerificacion.verificando = false;
      this.modalVerificacion.estActual = null;
      this.modalVerificacion.individual = false;
      this.lanIntegracion = false;
      this.navServicio.setMesage( 0, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
      } );
    });
  }

  enviarIntegraciones() {
    // Consumir servicio de verificacion de archivo
   this.lanIntegracion = true;
    this.solicitudOfertaGarantia.verificarIntegracion().subscribe(data => {
      this.modalVerificacion.estActual = 'INIT';
      this.excelAvance = data;
      this.lanIntegracion = false;
      this.modalVerificacion.verificando = true;
    }, error => {
      this.navServicio.setMesage(0,
        {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
        });
      this.lanIntegracion = false;
    });
  }

  conectarSocket() {
    this.topSubscription = this.rxStompService.watch('/topic/pendienteFGA.' + this.authService.obtenerIdUsuarioLogueado()).subscribe(async (message: Message) => {
      const body = (message && message.body) ? JSON.parse(message.body) : null;
      console.log(body);
      if (body && this.excelAvance && this.excelAvance.uid === body.uid) {
        this.excelAvance.avance = body.avance;
        this.excelAvance.errores = body.errores ? body.errores : [];
        this.excelAvance.totalRegistros = body.totalRegistros;
        if ((this.excelAvance.avance * 100) >= 100) {
          this.modalVerificacion.estActual = 'FINVER';
          this.modalVerificacion.error = this.excelAvance.errores.length > 0;
          this.procesoSocket = false;
        }
        this.procesoSocket = true;
      } else {
        this.procesoSocket = true;
        if (this.procesoSocket && this.ingresoUnico) {
          this.ingresoUnico = false;
          this.navServicio.setMesageToast(
            {
              key: 'toastMessage',
              severity: "info",
              life: 10000,
              summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_VERIFICACIONENCURSOFGA' ),
            }
          );
        }
      }
    });
  }

  async cerrarVerificacion(individual: boolean = false) {
    this.modalVerificacion.verificando = false;
    if (!individual) {
      this.showModalSolicitudes = false;
    } else {
      this.modalVerificacion.individual = false;
    }
    this.modalVerificacion.error = false;
    this.excelAvance = null;
    this.loading = true;
    await this.cargarContador();
    this.loading = false;
  }

  ngOnDestroy() {
    if (this.topSubscription) {
      this.topSubscription.unsubscribe();
      if ( this.excelAvance && this.excelAvance.uid ) {
        this.solicitudOfertaGarantia.cancelarLanzadoIntegracion(this.excelAvance.uid).subscribe();
      }
    }
  }

  modalConfirmacion( solicitud: any) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje("WIDGETMODAL.MSG_CANELARSOLICITUD"),
      header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
      icon: 'fa fa-question-circle',
      key: 'cambio-estado-garantia',
      accept: () => {
        this.verModal(solicitud);
      },
      reject: () => {
      }
    } );
  }

  verModal(solicitud) {
    const modal = this.diaService.open( CambioEstadosComponent, {
      header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_CANCELAR' ),
      width: '40%',
      closeOnEscape: false,
      closable: false,
      maskStyleClass: 'overflow-y-unset',
      data: {
        idSolicitud: solicitud.idSolicitud,
        idEstado: solicitud.idEstado,
        idProducto: solicitud.idProducto,
        idFase: solicitud.idFase,
        tipo: BotonesSolicitud.CANCELAR
      },
    } );
    modal.onClose.subscribe( async ( res: any ) => {
      if (res) {
        await this.solicitudOfertaGarantia.cancelarOfertaGarantia(solicitud.idSolicitudOfertaGarantia).toPromise();
        this.cargarSolicitudes();
      }
    } );
  }


}
